import { FilterableTable } from "components/FilterableTable";
import { CustomAlert } from "components";
import useModalReducer from "hooks/useModal";
import React, { useCallback } from "react";
import apiService from "services/api";
import NewAttendanceApplicationModal from "./NewAttendanceApplicationModal";
import { attendanceApplicationColumns } from "./constants";
import { Button } from "reactstrap";
import { useMutation } from "react-query";
import { useNotificationContext } from "contexts";

const AttendanceApplicationPage = () => {
	const [refetchCheck, setRefetchCheck] = React.useState(false);
	const { createNotification } = useNotificationContext();
	const { state: createModalState, dispatch: createModalDispatch, actions: createModalActions } = useModalReducer();
	const { state: deleteModalState, dispatch: deleteModalDispatch, actions: deleteModalActions } = useModalReducer();
	const openNewAttendanceApplicationModal = useCallback((row) => createModalDispatch({ type: createModalActions.OPEN, payload: row }), []);
	const hideAttendanceApplicationModal = useCallback((row) => createModalDispatch({ type: createModalActions.CLOSE, payload: row }), []);
	const openDeleteAttendanceApplicationModal = useCallback((row) => deleteModalDispatch({ type: deleteModalActions.OPEN, payload: row }), []);
	const hideDeleteAttendanceApplicationModal = useCallback((row) => deleteModalDispatch({ type: deleteModalActions.CLOSE, payload: row }), []);
	const { mutate: deleteAttendanceApplication, isLoading: isDeleting } = useMutation(
		() => apiService.attendance.application.delete(deleteModalState?.data?.id),
		{
			onSuccess: () => {
				setRefetchCheck((prev) => !prev);
				hideDeleteAttendanceApplicationModal();
				createNotification({ type: "success", message: "Successfully deleted attendance application!" });
			},
			onError: (err) => {
				createNotification({ type: "danger", message: err.message });
			},
		}
	);

	return (
		<div className="content">
			<CustomAlert
				title="Delete attendance application"
				show={deleteModalState?.open}
				hideModal={hideDeleteAttendanceApplicationModal}
				disabled={isDeleting}
				description="Are you sure you want to remove attendance application?"
				submitModal={deleteAttendanceApplication}
				submitButtonText="Delete"
			/>
			<Button color="info" className="mb-3" onClick={openNewAttendanceApplicationModal}>
				New Attendance
			</Button>
			<NewAttendanceApplicationModal
				show={createModalState?.open}
				data={createModalState?.data}
				hideModal={hideAttendanceApplicationModal}
				refetch={() => setRefetchCheck((prev) => !prev)}
			/>
			<FilterableTable
				query={(filters) => () => apiService.attendance.application.self(filters)}
				title="My Attendance Applications"
				actionPrepend
				queryKey={["attendanceApplications"]}
				columns={attendanceApplicationColumns(openDeleteAttendanceApplicationModal)}
				refetchCheck={refetchCheck}
				filters={[
					{
						filterName: "date_from",
						operator: "contains",
						placeholder: "Date",
						type: "date",
						label: "Date From",
					},
					{
						filterName: "date_to",
						operator: "contains",
						placeholder: "Date",
						type: "date",
						label: "Date To",
					},
					{ filterName: "centre", operator: "contains", placeholder: "Centre" },
					{ filterName: "teacher_name", operator: "contains", placeholder: "Teacher Name" },
				]}
			/>
		</div>
	);
};

export default AttendanceApplicationPage;
